(function () {
	'use strict';
	angular.module('app.leanProjects')
		.controller('newProject', newProject);

	newProject.$inject = ['$scope', '$timeout', '$rootScope', 'newProjectService', 'siteService', 'projectTemplatesService'];

	function newProject($scope, $timeout, $rootScope, newProjectService, siteService, projectTemplatesService) {
		var vm = this;
		var templateNdx = -1;

		// view model functions
		vm.close = close;
		vm.save = save;
		vm.categoryTagTransform = categoryTagTransform;
		vm.datePickerOpen = datePickerOpen;
		vm.chooseTemplate = chooseTemplate;
		vm.canApproveProject = canApproveProject;
		vm.startDateChanged = startDateChanged;
		vm.endDateChanged = endDateChanged;
		vm.areaSelected = areaSelected;
		vm.projectTypeSelected = projectTypeSelected;
		vm.categoriesSelected = categoriesSelected;
		vm.loadProjectForm = loadProjectForm;
		vm.selectSite = selectSite;
		vm.clearTemplate = clearTemplate;
		vm.goBackToSiteSelection = goBackToSiteSelection;
		vm.fromTemplate = false;
		vm.templateDaysOffset = 0;
		// 24hr after unix epoch, to avoid any timezone issues
		vm.minDate = new Date(86400000);
		vm.dateFormat = 'medium';
		vm.invalidDates = false;
		vm.factoryNdx = $scope.factoryNdx || globalConfig.factory.id;
		vm.isSaveButtonDisabled = false;
		vm.isNextButtonDisabled = true;
		vm.sites = siteService.getSitesByCustomer(globalConfig.customer.id);
		vm.showProjectDetails = false;
		vm.showBackArrow = false;
		vm.allowAreaTagging = false;

		initWithSites();

		function loadProjectDetailsForm() {
			getTemplates();
			init();
			vm.showProjectDetails = true;
		}
		function initWithSites() {
			if ($scope.factoryNdx) {
				var factory = globalConfig.user.authFacts[$scope.factoryNdx];
				vm.siteName = factory.alias || factory.name;
				loadProjectDetailsForm();
			}
			else if (vm.sites.length == 1) {
				vm.siteName = vm.sites[0].name;
				loadProjectDetailsForm();
			}
		}

		function init() {
			// Data from scope
			vm.embededModelData = {
				supplierNdx: $scope.supplierNdx,
				metricNdx: $scope.metricNdx
			};

			// other view model settings
			vm.isSupplierProject = $scope.isSupplierProject;
			if (userIsAdmin() || globalConfig.user.authFacts[vm.factoryNdx].initAuthz) {
				vm.allowCategoryTagging = true;
			} else {
				vm.allowCategoryTagging = false;
			}
			vm.categoryObjects = [];

			// init view model project
			vm.project = {};
			if (vm.isSupplierProject) {
				vm.project.type = 'Supplier';
				vm.project.isSupplierProject = true;
			} else {
				vm.project.type = 'Lean Initiative';
				vm.project.isSupplierProject = false;
			}
			vm.project.startDate = new Date();
			vm.project.endDate = moment(new Date()).add(14, 'days').toDate();
			vm.project.teamMembersOnly = false;
			vm.project.targetSavingsAnnual = vm.project.targetSavingsOneTime = vm.project.targetSavingsCostAvoidance = 0;

			// view model drop down lists that are coming from the caller scope
			var filtersToFetch = [];
			filtersToFetch.push({
				'filterName': 'ProjectArea',
				'variableName': 'areas'
			});
			filtersToFetch.push({
				'filterName': 'ProjectStageAll',
				'variableName': 'stages'
			});

			if ($scope.categoryList) {
				vm.categories = $scope.categoryList;
			} else {
				filtersToFetch.push({
					'filterName': 'ProjectCategories',
					'variableName': 'categories'
				});
			}

			if ($scope.typeList) {
				vm.types = $scope.typeList;
			} else {
				filtersToFetch.push({
					'filterName': 'ProjectTypes',
					'variableName': 'types'
				});
			}

			// view model static drop downs
			vm.viewableByOptions = [{
				'name': 'All users',
				'value': false
			}, {
				'name': 'Only members of this project',
				'value': true
			}];

			// view model drop down list that are retrieved from the server
			getDropDownListsFromServer(filtersToFetch);
		}

		function selectSite($selectSite) {
			vm.isNextButtonDisabled = !($selectSite && $selectSite.id);
			vm.siteName = $selectSite.name;
		}

		function loadProjectForm() {
			if (vm.selectedSite) {
				// set factory ndx
				vm.factoryNdx = _.clone(vm.selectedSite);
				loadProjectDetailsForm();
				vm.showBackArrow = true;
			}
		}

		function clearTemplate() {
			vm.isCrossSiteAreaMissing = false;
			vm.fromTemplate = false;
			vm.templateName = null;
			vm.project.name = null;
			vm.project.description = null;
			vm.project.area = null;
			vm.categoryObjects = null;
			if (!vm.isSupplierProject) {
				vm.project.type = null;
			}
			vm.project.isSupplierProject = vm.isSupplierProject;
			templateNdx = -1;
			vm.project.areaNdx = null;
			vm.project.projectTypeId = null;
			vm.project.startDate = new Date();
			vm.project.endDate = moment(new Date()).add(14, 'days').toDate();
		}

		function goBackToSiteSelection() {
			clearTemplate();
			vm.showProjectDetails = false;
		}

		function canApproveProject() {
			return (userIsAdmin() || globalConfig.user.initAuthz);
		}

		function userIsAdmin() {
			return (globalConfig.user.authFacts[vm.factoryNdx].profileType === 'SuperSystemAdministrator')
				|| (globalConfig.user.authFacts[vm.factoryNdx].profileType === 'SystemAdministrator');
		}

		function getDropDownListsFromServer(filtersToFetch) {
			if (vm.isSupplierProject) {
				newProjectService.getFilterData('Supplier', 'suppliers', vm.factoryNdx).then(function (suppliers) {
					vm.suppliers = suppliers.data;

					if (vm.embededModelData.supplierNdx) {
						vm.project.supplierNdx = vm.embededModelData.supplierNdx;
					}
				});
			}
			newProjectService.getUsers(vm.factoryNdx, undefined, true).then(function (users) {
				vm.projectManagers = users;
			});
			for (var i = 0; i < filtersToFetch.length; i++) {
				var filterName = filtersToFetch[i].filterName;
				var variableName = filtersToFetch[i].variableName;
				newProjectService.getFilterData(filterName, variableName, vm.factoryNdx).then(function (filterData) {
					var data = filterData.data;
					if (typeof data !== 'undefined' && data != '') {
						if (filterData.id === 'projectStageId') {
							vm.project.stageId = getDefaultStageId(data);
						} else if (filterData.id === 'projectArea') {
							data = data.map(function (obj) {
								return {
									'name': obj.projectArea,
									'ndx': obj.areaNdx
								};
							});
						} else if (filterData.id === 'projectCategoryId') {
							data = data.map(function (obj) {
								return {
									'name': obj.projectCategoryName,
									'id': obj.projectCategoryId,
									'status': obj.statuses
								};
							});
						} else if (filterData.id === 'projectType') {
							data = data.map(function (obj) {
								return {
									'name': obj.projectTypeName,
									'id': parseInt(obj.projectTypeId)
								};
							});
						}
					}

					vm[filterData.variableName] = data;
				});
			}
		}

		function save() {
			vm.isSaveButtonDisabled = true;
			var categoryObjs = vm.categoryObjects;
			vm.project.categoryIds = [];
			vm.project.newCategories = [];
			for (var i = 0; i < categoryObjs.length; i++) {
				if (categoryObjs[i].isTag) {
					vm.project.newCategories.push(categoryObjs[i].name);
				} else {
					vm.project.categoryIds.push(categoryObjs[i].id);
				}
			}
			var data = angular.copy(vm.project);
			if (('' + data.areaNdx).indexOf('tag-') === 0) {
				data.newArea = data.areaNdx.substring(4);
				data.areaNdx = undefined;
			}

			if (('' + data.projectTypeId).indexOf('tag-') === 0) {
				data.newProjectType = data.projectTypeId.substring(4);
				data.projectTypeId = undefined;
			}

			var projectStartDateUtc = moment(data.startDate)
				.subtract(data.startDate.getTimezoneOffset(), 'minutes');
			data.startDate = moment(projectStartDateUtc)._d;
			var projectCompleteDateUtc = moment(data.endDate)
				.subtract(data.endDate.getTimezoneOffset(), 'minutes');
			data.endDate = moment(projectCompleteDateUtc)._d;

			newProjectService.saveProject(data, vm.factoryNdx, templateNdx, vm.embededModelData.metricNdx)
				.then(function (message) {
					if (message != 'Project created successfully') {
						$rootScope.$emit('toast', {
							'message': message,
							'success': false
						});
					} else {
						$scope.result(message, true, vm.project.stageId);
					}
					vm.isSaveButtonDisabled = false;
				});
		}

		function close() {
			$scope.result('', false);
		}

		function categoryTagTransform(newTag) {
			var item = {
				'name': newTag,
				'id': -1
			};
			return item;
		}

		function getDefaultStageId(stageList) {
			for (var i = 0; i < stageList.length; i++) {
				if (stageList[i].name === 'Pending Approval') {
					return stageList[i].id;
				}
			}
			return undefined;
		}

		function datePickerOpen(type) {
			$timeout(function () {
				if (type === 'start') {
					vm.startDateOpened = true;
				} else {
					vm.endDateOpened = true;
				}
			});
		}

		function getTemplates() {
			newProjectService.getTemplates(vm.factoryNdx).then(function (templates) {
				vm.templates = templates;
				chooseDefaultTemplate();
			});
		}

		function chooseTemplate(index) {
			var temp = vm.templates[index];
			setDataFromTemplate(temp);
		}

		function chooseDefaultTemplate() {
			projectTemplatesService.getProjectTemplateDefault(vm.factoryNdx).then(function (response) {
				var projectTemplateDefault = response.data;
				if (!projectTemplateDefault || !vm.templates.length) {
					return;
				}
				var defaultTemplate = vm.templates.find(function (template) {
					return template.ndx === projectTemplateDefault.templateNdx;
				});
				if (defaultTemplate) {
					setDataFromTemplate(defaultTemplate);
				}
			});
		}

		function setDataFromTemplate(temp) {
			vm.fromTemplate = true;
			vm.templateName = temp.name;
			vm.project.name = temp.name;
			vm.project.description = temp.description;
			vm.project.area = temp.area;
			vm.templateDaysOffset = temp.templateDuration;
			if (moment(vm.project.startDate).add(vm.templateDaysOffset, 'days').isAfter(vm.project.endDate)) {
				//Move out date
				vm.project.endDate = moment(vm.project.startDate).add(vm.templateDaysOffset, 'days').toDate();
			}

			if (!vm.isSupplierProject) {
				vm.project.type = temp.type;
			}
			vm.project.isSupplierProject = vm.isSupplierProject;
			templateNdx = temp.ndx;
			setCategoriesFromTemplate(temp);

			var list = vm.areas ? vm.areas.filter(function (item) {
				return item.name == temp.area;
			}) : [];

			if (list.length == 0) {
				if (temp.isCrossSite) {
					vm.isCrossSiteTemplate = temp.isCrossSite;
					if (temp.factoryNdx === vm.factoryNdx) {
						// Add the area to list
						addMissingArea(temp);
						vm.project.areaNdx = temp.areaNdx.toString();
					} else {
						vm.isCrossSiteAreaMissing = !vm.project.areaNdx;
						vm.crossSiteArea = temp.area;
						return;
					}
				} else {
					vm.isCrossSiteAreaMissing = !vm.project.areaNdx;
					vm.crossSiteArea = temp.area;
					return;
				}
			} else {
				vm.project.areaNdx = list[0].ndx;
			}
			setProjectTypeFromTemplate(temp);
		}

		function setProjectTypeFromTemplate(templateData) {
			var list = vm.types ? vm.types.filter(function (item) {
				return item.name == templateData.type;
			}) : [];
			if (list.length == 0) {
				if (templateData.isCrossSite) {
					vm.isCrossSiteTemplate = templateData.isCrossSite;
					if (templateData.factoryNdx === vm.factoryNdx) {
						// Add the area to list
						addMissingProjectType(templateData);
					} else {
						if (userIsAdmin() || globalConfig.user.authFacts[vm.factoryNdx].initAuthz) {
							templateData.projectTypeId = 'tag-' + templateData.type;
							addMissingProjectType(templateData);
						} else {
							vm.isCrossSiteProjectTypeMissing = !vm.project.projectTypeId;
							vm.crossSiteProjectType = templateData.type;
							return;
						}
					}
				} else {
					addMissingProjectType(templateData);
				}
				vm.project.projectTypeId = templateData.projectTypeId.toString();
			} else {
				vm.project.projectTypeId = list[0].id;
			}
		}

		function setCategoriesFromTemplate(template) {
			var categories = template.categories;
			if (categories && categories.length) {
				categories = _.uniqBy(categories, function (category) {
					return category.id;
				}).filter(function (category) {
					return category.status !== 'Archive';
				});
				if (template.isCrossSite) {
					vm.isCrossSiteTemplate = template.isCrossSite;
					if (template.factoryNdx === vm.factoryNdx) {
						vm.categoryObjects = categories;
					} else {
						if (userIsAdmin() || globalConfig.user.authFacts[vm.factoryNdx].initAuthz) {
							vm.categoryObjects = categories.map(function (category) {
								category.isTag = true;
								return category;
							});
						} else {
							vm.isCrossSiteCategoriesMissing = !vm.categoryObjects || !vm.categoryObjects.length;
							vm.crossSiteCategories = categories;
						}
					}
				} else {
					vm.categoryObjects = categories;
				}
			}
		}

		function addMissingProjectType(temp) {
			vm.types.push({
				name: temp.type,
				id: temp.projectTypeId.toString()
			});
		}
			
		function addMissingArea(temp) {
			vm.areas.push({
				name: temp.area,
				ndx: temp.areaNdx.toString()
			});
		}

		function startDateChanged() {
			if (vm.fromTemplate) {
				//Always update project due date when project start date is changed.
				vm.project.endDate = moment(vm.project.startDate).add(vm.templateDaysOffset, 'days').toDate();
				vm.endDateClass = 'changed';
				$timeout(function() {
					vm.endDateClass = 'unchanged';
				}, 1000);
			}
			checkDates();
		}

		function endDateChanged() {
			checkDates();
		}

		function checkDates() {
			var startDate = moment(vm.project.startDate);
			var endDate = moment(vm.project.endDate);
			if(startDate && endDate) {
				vm.invalidDates = startDate.isAfter(endDate, 'days');
			}
		}

		function areaSelected() {
			if (vm.isCrossSiteTemplate) {
				vm.isCrossSiteAreaMissing = false;
			}
		}

		function projectTypeSelected() {
			if (vm.isCrossSiteTemplate) {
				vm.isCrossSiteProjectTypeMissing = false;
			}
		}

		function categoriesSelected() {
			if (vm.isCrossSiteTemplate) {
				vm.isCrossSiteCategoriesMissing = false;
			}
		}
	}
})();
